module.exports = __webpack_public_path__ + "img/22_3.d5410c3a.png";